/* Qalbeen · qalbeen.store · bloc « Offre » des fiches (snippets/qb-offre-fiche.liquid).
   - Reste du monde [data-qbo="world"] : lots 1 / 3 / 5. Prix du lot = somme des variantes choisies, moins le ou les moins chers
     (1 offert sur 3, 2 offerts sur 5 : même règle que la réduction automatique Shopify). Lot de plus d'un article : le bouton
     d'achat de la fiche ajoute tous les articles en une fois (/cart/add.js, items groupés par variante), puis le tiroir s'ouvre
     (assets/hover-cart.js voit l'ajout). Lot d'un article : le formulaire normal de la fiche (quantité 1).
   - Malaisie [data-qbo="my"] : échelle des cadeaux selon produits déjà au panier + quantité choisie + éditions cochées ;
     éditions cochées ajoutées avec le produit en une fois. Le panier annonce son état par l'événement « qb:cart ».
   Chargé en defer, ne s'installe qu'une fois. */
(function () {
  'use strict';
  if (window.QBOffre) return;
  var D = document, W = window;
  var R = ((W.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var $$ = function (s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); };
  var $ = function (s, c) { return (c || D).querySelector(s); };

  function fmtDe(sample) {
    var m = String(sample || '').match(/^(.*?)1([^0-9]?)234(?:([^0-9])56)?(.*)$/);
    return function (c) {
      c = Math.round(c);
      if (m) { var ent = Math.floor(c / 100), cts = ('0' + (c % 100)).slice(-2); return m[1] + String(ent).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]) + (m[3] ? m[3] + cts : '') + m[4]; }
      return (c / 100).toFixed(2);
    };
  }
  function ajouter(items) {
    return fetch(R + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error(j.description || j.message || ''); return j; }); });
  }
  function grouper(ids) {
    var o = {}, out = [];
    ids.forEach(function (id) { if (!o[id]) { o[id] = { id: id, quantity: 0 }; out.push(o[id]); } o[id].quantity++; });
    return out;
  }
  /* bouton d'achat de la fiche : on passe devant le formulaire Dawn quand il faut ajouter plusieurs articles */
  function brancher(sec, box, preparer) {
    var atc = $('[data-hvp-atc]', sec), err = $('[data-qbo-err]', box), enCours = false;
    if (!atc) return;
    atc.addEventListener('click', function (e) {
      if (atc.disabled || enCours) return;
      var items = preparer(); if (!items) return;
      e.preventDefault(); e.stopImmediatePropagation();
      enCours = true; atc.classList.add('loading'); atc.setAttribute('aria-busy', 'true');
      var sp = $('.loading__spinner', atc); if (sp) sp.classList.remove('hidden');
      if (err) err.hidden = true;
      ajouter(items).then(function () {
        if (!W.HVCart) W.location.href = R + 'cart';
        try { box.dispatchEvent(new CustomEvent('qbo:ajoute', { bubbles: true })); } catch (x) {}
      }, function (x) {
        if (err) { err.textContent = x.message || 'Sorry, something went wrong. Please try again.'; err.hidden = false; }
      }).then(function () {
        enCours = false; atc.classList.remove('loading'); atc.removeAttribute('aria-busy');
        if (sp) sp.classList.add('hidden');
      });
    }, true);
  }

  /* ---------- reste du monde : lots ---------- */
  function monde(box) {
    var sec = box.closest('[data-hvp]') || D;
    var data = {}; try { data = JSON.parse(($('[data-qbo-data]', box) || {}).textContent || '{}'); } catch (e) {}
    var money = fmtDe(data.money), prix = {};
    (data.v || []).forEach(function (x) { prix[x.id] = x.p; });
    var idIn = $('[data-hvp-id]', sec), qty = $('[data-hvp-qty]', sec), tot = $('[data-hvp-total]', sec);
    var vars = $('[data-hvp-vars]', sec), multi = box.getAttribute('data-multi') === 'true';
    sec.classList.add('hvp--qbo');
    var opts = $$('[data-qbo-opt]', box);
    function courant() { return +((idIn && idIn.value) || (data.v && data.v[0] && data.v[0].id) || 0); }
    function choisi() { var o = $('[data-qbo-opt].on', box); return o || opts[0]; }
    function ids(opt) {
      var n = +opt.getAttribute('data-qbo-opt'), sel = $$('[data-qbo-item]', opt);
      if (sel.length) return sel.map(function (s) { return +s.value; });
      var a = []; for (var i = 0; i < n; i++) a.push(courant()); return a;
    }
    function calcul(opt) {
      var l = ids(opt), free = +opt.getAttribute('data-free') || 0;
      var ps = l.map(function (id) { return prix[id] || 0; }).sort(function (a, b) { return a - b; });
      var was = ps.reduce(function (s, p) { return s + p; }, 0), save = ps.slice(0, free).reduce(function (s, p) { return s + p; }, 0);
      return { was: was, save: save, pay: was - save };
    }
    function peindre() {
      opts.forEach(function (opt) {
        var c = calcul(opt), put = function (k, v) { var el = $('[data-qbo-' + k + ']', opt); if (el) el.textContent = money(v); };
        put('pay', c.pay); if (+opt.getAttribute('data-free')) { put('was', c.was); put('save', c.save); }
      });
      var o = choisi(), n = +o.getAttribute('data-qbo-opt');
      if (vars && multi) vars.hidden = n > 1;
      if (n > 1) { if (tot) tot.textContent = money(calcul(o).pay); }
      else if (qty) { qty.value = 1; qty.dispatchEvent(new Event('input', { bubbles: true })); }
    }
    box.addEventListener('change', function (e) {
      var r = e.target.closest('input[type="radio"]');
      if (r) opts.forEach(function (o) { o.classList.toggle('on', o.contains(r)); });
      peindre();
    });
    /* modèle choisi dans les pastilles de la fiche : il devient le modèle par défaut de chaque article du lot */
    sec.addEventListener('hvp:variant', function (e) {
      var id = e.detail && e.detail.id; if (!id) return;
      $$('[data-qbo-item]', box).forEach(function (s) { var op = $('option[value="' + id + '"]', s); if (op && !op.disabled) s.value = String(id); });
      setTimeout(peindre, 0);
    });
    brancher(sec, box, function () {
      var o = choisi(); if (+o.getAttribute('data-qbo-opt') <= 1) return null;
      return grouper(ids(o));
    });
    peindre();
  }

  /* ---------- Malaisie : choix du lot (1 · Buy 2, get 1 · Buy 3, get 2) ----------
     Prix payé = somme des produits choisis ; économie = valeur des cadeaux du palier (Yusra dès 2, + édition dès 3),
     que le panier ajoute tout seul. Le lot choisi est annoncé à l'échelle des cadeaux par l'événement « qbo:lot ». */
  function lotsMy(box) {
    var sec = box.closest('[data-hvp]') || D;
    var data = {}; try { data = JSON.parse(($('[data-qbo-data]', box) || {}).textContent || '{}'); } catch (e) {}
    var money = fmtDe(data.money), opts = $$('[data-qbo-opt]', box), idIn = $('[data-hvp-id]', sec);
    function choisi() { return $('[data-qbo-opt].on', box) || opts[0]; }
    function prixDe(sel) { var o = sel.options[sel.selectedIndex]; return o ? +o.getAttribute('data-p') || 0 : 0; }
    function peindre() {
      opts.forEach(function (opt) {
        var n = +opt.getAttribute('data-qbo-opt'), sels = $$('[data-qbo-item]', opt), fv = +opt.getAttribute('data-free-v') || 0;
        var pay = sels.length ? sels.reduce(function (t, s) { return t + prixDe(s); }, 0) : n * (+(idIn && idIn.getAttribute('data-p')) || 0);
        var put = function (k, v) { var el = $('[data-qbo-' + k + ']', opt); if (el) el.textContent = money(v); };
        if (sels.length) { put('pay', pay); put('was', pay + fv); }
        put('save', fv);
      });
      var o = choisi(), n = +o.getAttribute('data-qbo-opt'), tot = $('[data-hvp-total]', sec), qty = $('[data-hvp-qty]', sec);
      if (n > 1) { if (tot) tot.textContent = money($$('[data-qbo-item]', o).reduce(function (t, s) { return t + prixDe(s); }, 0)); }
      else if (qty) { qty.value = 1; qty.dispatchEvent(new Event('input', { bubbles: true })); }
      try { sec.dispatchEvent(new CustomEvent('qbo:lot', { detail: { n: n } })); } catch (x) {}
    }
    box.addEventListener('change', function (e) {
      var r = e.target.closest && e.target.closest('input[type=radio]');
      if (r) opts.forEach(function (o) { o.classList.toggle('on', o.contains(r)); });
      peindre();
    });
    // pastilles visibles (couleur ou édition) → menu caché de chaque produit du lot
    function nomsPk() { $$('.qbo-pk', box).forEach(function (pk) { var b = $('[data-qbo-pk][aria-pressed="true"]', pk), n = $('[data-qbo-pk-nom]', pk); if (n) n.textContent = b ? b.getAttribute('data-nom') : ''; }); }
    box.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-qbo-pk]'); if (!b) return;
      e.preventDefault();
      var pk = b.closest('.qbo-pk'), sel = $('[data-qbo-item]', pk);
      $$('[data-qbo-pk]', pk).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      if (sel) sel.value = b.getAttribute('data-qbo-pk');
      nomsPk(); peindre();
    });
    nomsPk();
    sec.addEventListener('hvp:variant', function (e) {
      var id = e.detail && (e.detail.id || (e.detail.variant && e.detail.variant.id)); if (!id) return;
      $$('.qbo-pk', box).forEach(function (pk) {
        var sel = $('[data-qbo-item]', pk), b = $('[data-qbo-pk="' + id + '"]', pk); if (!sel || !b) return;
        sel.value = String(id); $$('[data-qbo-pk]', pk).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
      nomsPk();
      peindre();
    });
    brancher(sec, box, function () {
      var o = choisi(); if (+o.getAttribute('data-qbo-opt') <= 1) return null;
      return grouper($$('[data-qbo-item]', o).map(function (s) { return +s.value; }));
    });
    peindre();
  }

  /* ---------- Malaisie : échelle des cadeaux + éditions à ajouter ---------- */
  function malaisie(box) {
    var sec = box.closest('[data-hvp]') || D;
    var qty = $('[data-hvp-qty]', sec), idIn = $('[data-hvp-id]', sec), msg = $('[data-qbo-msg]', box);
    var nCart = +box.getAttribute('data-cart-n') || 0;
    var lotN = 0;   // lot choisi au-dessus du bouton (0 = pas de choix de lot sur la fiche)
    if ($('[data-qbo="mylots"]', sec)) { var sg = $('.qbo-sugg', box); if (sg) sg.hidden = true; }
    function coches() { return $$('[data-qbo-add]', box).filter(function (c) { return c.checked; }); }
    function peindre() {
      // Coché (ok) = déjà acquis avec le panier actuel ; « next » = débloqué SI on ajoute ce qui est choisi (pas encore coché).
      var lb = $('[data-qbo="mylots"] [data-qbo-opt].on', sec); lotN = lb ? +lb.getAttribute('data-qbo-opt') : 0;
      var q = lotN > 1 ? lotN : (qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1), P = nCart + q + coches().length;
      $$('[data-qbo-rung]', box).forEach(function (li) {
        var r = +li.getAttribute('data-qbo-rung'), ok = nCart >= r, nx = !ok && P >= r;
        li.classList.toggle('ok', ok); li.classList.toggle('next', nx);
        var tag = $('.qbo-ladder__next', li);
        if (nx && !tag) { tag = D.createElement('em'); tag.className = 'qbo-ladder__next'; tag.textContent = 'Unlocked when you add this'; $('.qbo-ladder__t', li).appendChild(tag); }
        if (!nx && tag) tag.remove();
      });
      var t, gifts = function (n) { return n >= 3 ? '<b>gift pouches, a Yusra Hijab and a card edition</b>' : n === 2 ? '<b>2 gift pouches and a Yusra Hijab</b>' : '<b>a free gift pouch</b>'; };
      if (nCart >= 3) t = 'All the gifts are unlocked in your cart: ' + gifts(3) + '. Each extra product adds one more gift pouch.';
      else if (nCart > 0) t = 'Your cart has ' + nCart + ' product' + (nCart > 1 ? 's' : '') + ' (' + gifts(nCart) + '). Adding this brings you to ' + P + ': ' + gifts(P) + '.';
      else t = 'Add this to your cart and get ' + gifts(P) + '. ' + (P < 2 ? 'Two products unlock a <b>free Yusra Hijab</b>.' : P < 3 ? 'Three products unlock a <b>free card edition</b>.' : '');
      if (msg) msg.innerHTML = t;
      $$('.qbo-add', box).forEach(function (l) { var c = $('input', l); l.classList.toggle('on', !!(c && c.checked)); });
    }
    // L'encadré est SOUS le bouton d'achat (demande de Wyssem) : cocher une édition l'ajoute tout de suite au panier
    // (le tiroir s'ouvre, l'échelle se met à jour par « qb:cart »), sans attendre un nouveau clic sur « Add to cart ».
    box.addEventListener('change', function (e) {
      var c = e.target.closest && e.target.closest('[data-qbo-add]');
      if (c && c.checked) {
        var l = c.closest('.qbo-add'); if (l) l.classList.add('loading');
        ajouter([{ id: +c.getAttribute('data-qbo-add'), quantity: 1 }]).then(function () {
          if (!W.HVCart) W.location.href = R + 'cart';
          if (l) { l.classList.add('fait'); setTimeout(function () { l.classList.remove('fait'); }, 2500); }
        }, function (x) { var err = $('[data-qbo-err]', box); if (err) { err.textContent = x.message || 'Sorry, something went wrong. Please try again.'; err.hidden = false; } })
          .then(function () { c.checked = false; if (l) l.classList.remove('loading'); peindre(); });
        return;
      }
      peindre();
    });
    if (qty) { qty.addEventListener('input', peindre); qty.addEventListener('change', peindre); }
    sec.addEventListener('click', function (e) { if (e.target.closest('[data-hvp-q]')) setTimeout(peindre, 0); });
    D.addEventListener('qb:cart', function (e) { if (e.detail && typeof e.detail.n === 'number') { nCart = e.detail.n; peindre(); } });
    sec.addEventListener('qbo:lot', function (e) { lotN = (e.detail && e.detail.n) || 0; peindre(); });
    box.addEventListener('qbo:ajoute', function () { coches().forEach(function (c) { c.checked = false; }); peindre(); });
    brancher(sec, box, function () {
      var c = coches(); if (!c.length || !idIn) return null;
      var q = qty ? Math.max(1, parseInt(qty.value, 10) || 1) : 1;
      return [{ id: +idIn.value, quantity: q }].concat(c.map(function (x) { return { id: +x.getAttribute('data-qbo-add'), quantity: 1 }; }));
    });
    peindre();
  }

  function init() {
    $$('[data-qbo]').forEach(function (b) {
      if (b._qbo) return; b._qbo = 1;
      var t = b.getAttribute('data-qbo');
      if (t === 'world') monde(b); else if (t === 'mylots') lotsMy(b); else malaisie(b);
    });
  }
  W.QBOffre = { init: init };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
  D.addEventListener('shopify:section:load', init);
})();
